//@ts-nocheck
  // DO NOT MODIFY THIS FILE. This file is automatically generated by Tina
  export function gql(strings: TemplateStringsArray, ...args: string[]): string {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (args[i] || '')
    })
    return str
  }
  export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** References another document, used as a foreign key */
  Reference: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  filename: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  hasReferences?: Maybe<Scalars['Boolean']['output']>;
  breadcrumbs: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  template: Scalars['String']['output'];
  collection: Collection;
};


export type SystemInfoBreadcrumbsArgs = {
  excludeExtension?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasPreviousPage: Scalars['Boolean']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  endCursor: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Document = {
  id: Scalars['ID']['output'];
  _sys?: Maybe<SystemInfo>;
  _values: Scalars['JSON']['output'];
};

/** A relay-compliant pagination connection */
export type Connection = {
  totalCount: Scalars['Float']['output'];
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  getOptimizedQuery?: Maybe<Scalars['String']['output']>;
  collection: Collection;
  collections: Array<Collection>;
  node: Node;
  document: DocumentNode;
  post: Post;
  postConnection: PostConnection;
  author: Author;
  authorConnection: AuthorConnection;
  category: Category;
  categoryConnection: CategoryConnection;
  lesson: Lesson;
  lessonConnection: LessonConnection;
};


export type QueryGetOptimizedQueryArgs = {
  queryString: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostFilter>;
};


export type QueryAuthorArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuthorConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuthorFilter>;
};


export type QueryCategoryArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CategoryFilter>;
};


export type QueryLessonArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLessonConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LessonFilter>;
};

export type DocumentFilter = {
  post?: InputMaybe<PostFilter>;
  author?: InputMaybe<AuthorFilter>;
  category?: InputMaybe<CategoryFilter>;
  lesson?: InputMaybe<LessonFilter>;
};

export type DocumentConnectionEdges = {
  __typename?: 'DocumentConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<DocumentNode>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<DocumentConnectionEdges>>>;
};

export type Collection = {
  __typename?: 'Collection';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  documents: DocumentConnection;
};


export type CollectionDocumentsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentNode = Post | Author | Category | Lesson | Folder;

export type PostCategory = Category;

export type PostOpeningVariations = {
  __typename?: 'PostOpeningVariations';
  name: Scalars['String']['output'];
  moves?: Maybe<Scalars['String']['output']>;
  fen?: Maybe<Scalars['String']['output']>;
};

export type PostOpening = {
  __typename?: 'PostOpening';
  name?: Maybe<Scalars['String']['output']>;
  moves?: Maybe<Scalars['String']['output']>;
  lessonSlug?: Maybe<Scalars['String']['output']>;
  ecoCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  side?: Maybe<Scalars['String']['output']>;
  skillLevels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  character?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  keyIdeas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  variations?: Maybe<Array<Maybe<PostOpeningVariations>>>;
};

export type PostHeroBoardArrows = {
  __typename?: 'PostHeroBoardArrows';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

export type PostHeroBoardHighlights = {
  __typename?: 'PostHeroBoardHighlights';
  square?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type PostHeroBoard = {
  __typename?: 'PostHeroBoard';
  fen: Scalars['String']['output'];
  playingWhite?: Maybe<Scalars['Boolean']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  arrows?: Maybe<Array<Maybe<PostHeroBoardArrows>>>;
  highlights?: Maybe<Array<Maybe<PostHeroBoardHighlights>>>;
};

export type PostAuthor = Author;

export type Post = Node & Document & {
  __typename?: 'Post';
  postId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  category?: Maybe<PostCategory>;
  subtopic?: Maybe<Scalars['String']['output']>;
  template: Scalars['String']['output'];
  isSubtopicPage?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  opening?: Maybe<PostOpening>;
  excerpt?: Maybe<Scalars['JSON']['output']>;
  heroBoard?: Maybe<PostHeroBoard>;
  heroImg?: Maybe<Scalars['String']['output']>;
  cardImg?: Maybe<Scalars['String']['output']>;
  author?: Maybe<PostAuthor>;
  date?: Maybe<Scalars['String']['output']>;
  _body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type StringFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostCategoryFilter = {
  category?: InputMaybe<CategoryFilter>;
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostOpeningVariationsFilter = {
  name?: InputMaybe<StringFilter>;
  moves?: InputMaybe<StringFilter>;
  fen?: InputMaybe<StringFilter>;
};

export type PostOpeningFilter = {
  name?: InputMaybe<StringFilter>;
  moves?: InputMaybe<StringFilter>;
  lessonSlug?: InputMaybe<StringFilter>;
  ecoCodes?: InputMaybe<StringFilter>;
  aliases?: InputMaybe<StringFilter>;
  side?: InputMaybe<StringFilter>;
  skillLevels?: InputMaybe<StringFilter>;
  character?: InputMaybe<StringFilter>;
  keyIdeas?: InputMaybe<StringFilter>;
  variations?: InputMaybe<PostOpeningVariationsFilter>;
};

export type RichTextFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberFilter = {
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type PostHeroBoardArrowsFilter = {
  from?: InputMaybe<StringFilter>;
  to?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  opacity?: InputMaybe<NumberFilter>;
};

export type PostHeroBoardHighlightsFilter = {
  square?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  opacity?: InputMaybe<NumberFilter>;
  style?: InputMaybe<StringFilter>;
};

export type PostHeroBoardFilter = {
  fen?: InputMaybe<StringFilter>;
  playingWhite?: InputMaybe<BooleanFilter>;
  caption?: InputMaybe<StringFilter>;
  arrows?: InputMaybe<PostHeroBoardArrowsFilter>;
  highlights?: InputMaybe<PostHeroBoardHighlightsFilter>;
};

export type PostAuthorFilter = {
  author?: InputMaybe<AuthorFilter>;
};

export type DatetimeFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Post_BodySvgViewerFilter = {
  data?: InputMaybe<StringFilter>;
};

export type Post_BodyFreeTurnBoardFilter = {
  title?: InputMaybe<StringFilter>;
  fen?: InputMaybe<StringFilter>;
  edgeColor?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
};

export type Post_BodyChallengeBoardFilter = {
  title?: InputMaybe<StringFilter>;
  fen?: InputMaybe<StringFilter>;
  moves?: InputMaybe<StringFilter>;
  edgeColor?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
};

export type Post_BodyLessonBoardLinesFilter = {
  moves?: InputMaybe<StringFilter>;
  comments?: InputMaybe<StringFilter>;
};

export type Post_BodyLessonBoardFilter = {
  title?: InputMaybe<StringFilter>;
  openingFen?: InputMaybe<StringFilter>;
  openingLastMove?: InputMaybe<StringFilter>;
  introText?: InputMaybe<StringFilter>;
  playingWhite?: InputMaybe<BooleanFilter>;
  edgeColor?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
  lines?: InputMaybe<Post_BodyLessonBoardLinesFilter>;
};

export type Post_BodyDisplayBoardArrowsFilter = {
  from?: InputMaybe<StringFilter>;
  to?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  opacity?: InputMaybe<NumberFilter>;
};

export type Post_BodyDisplayBoardHighlightsFilter = {
  square?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  opacity?: InputMaybe<NumberFilter>;
  style?: InputMaybe<StringFilter>;
};

export type Post_BodyDisplayBoardFilter = {
  title?: InputMaybe<StringFilter>;
  fen?: InputMaybe<StringFilter>;
  boardSize?: InputMaybe<NumberFilter>;
  playingWhite?: InputMaybe<BooleanFilter>;
  edgeColor?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
  arrows?: InputMaybe<Post_BodyDisplayBoardArrowsFilter>;
  highlights?: InputMaybe<Post_BodyDisplayBoardHighlightsFilter>;
};

export type Post_BodySimpleGameViewerFilter = {
  title?: InputMaybe<StringFilter>;
  pgn?: InputMaybe<StringFilter>;
  playingWhite?: InputMaybe<BooleanFilter>;
  boardSize?: InputMaybe<NumberFilter>;
  edgeColor?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
};

export type Post_BodyGameViewerGameReviewChessTermsArrowsFilter = {
  from?: InputMaybe<StringFilter>;
  to?: InputMaybe<StringFilter>;
};

export type Post_BodyGameViewerGameReviewChessTermsTranslationKeysFilter = {
  piece?: InputMaybe<StringFilter>;
  pieces?: InputMaybe<StringFilter>;
  square?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
};

export type Post_BodyGameViewerGameReviewChessTermsFilter = {
  term?: InputMaybe<StringFilter>;
  termAction?: InputMaybe<StringFilter>;
  arrows?: InputMaybe<Post_BodyGameViewerGameReviewChessTermsArrowsFilter>;
  translationKeys?: InputMaybe<Post_BodyGameViewerGameReviewChessTermsTranslationKeysFilter>;
};

export type Post_BodyGameViewerGameReviewFilter = {
  fen?: InputMaybe<StringFilter>;
  move?: InputMaybe<StringFilter>;
  score?: InputMaybe<NumberFilter>;
  moveType?: InputMaybe<StringFilter>;
  chessTerms?: InputMaybe<Post_BodyGameViewerGameReviewChessTermsFilter>;
};

export type Post_BodyGameViewerFilter = {
  title?: InputMaybe<StringFilter>;
  playingWhite?: InputMaybe<BooleanFilter>;
  gameReview?: InputMaybe<Post_BodyGameViewerGameReviewFilter>;
  edgeColor?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
};

export type Post_BodyFilter = {
  SvgViewer?: InputMaybe<Post_BodySvgViewerFilter>;
  FreeTurnBoard?: InputMaybe<Post_BodyFreeTurnBoardFilter>;
  ChallengeBoard?: InputMaybe<Post_BodyChallengeBoardFilter>;
  LessonBoard?: InputMaybe<Post_BodyLessonBoardFilter>;
  DisplayBoard?: InputMaybe<Post_BodyDisplayBoardFilter>;
  SimpleGameViewer?: InputMaybe<Post_BodySimpleGameViewerFilter>;
  GameViewer?: InputMaybe<Post_BodyGameViewerFilter>;
};

export type PostFilter = {
  postId?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  subtitle?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  category?: InputMaybe<PostCategoryFilter>;
  subtopic?: InputMaybe<StringFilter>;
  template?: InputMaybe<StringFilter>;
  isSubtopicPage?: InputMaybe<BooleanFilter>;
  locale?: InputMaybe<StringFilter>;
  opening?: InputMaybe<PostOpeningFilter>;
  excerpt?: InputMaybe<RichTextFilter>;
  heroBoard?: InputMaybe<PostHeroBoardFilter>;
  heroImg?: InputMaybe<StringFilter>;
  cardImg?: InputMaybe<StringFilter>;
  author?: InputMaybe<PostAuthorFilter>;
  date?: InputMaybe<DatetimeFilter>;
  _body?: InputMaybe<Post_BodyFilter>;
};

export type PostConnectionEdges = {
  __typename?: 'PostConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Post>;
};

export type PostConnection = Connection & {
  __typename?: 'PostConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<PostConnectionEdges>>>;
};

export type Author = Node & Document & {
  __typename?: 'Author';
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  xHandle?: Maybe<Scalars['String']['output']>;
  _body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type AuthorFilter = {
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  xHandle?: InputMaybe<StringFilter>;
  _body?: InputMaybe<RichTextFilter>;
};

export type AuthorConnectionEdges = {
  __typename?: 'AuthorConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Author>;
};

export type AuthorConnection = Connection & {
  __typename?: 'AuthorConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<AuthorConnectionEdges>>>;
};

export type Category = Node & Document & {
  __typename?: 'Category';
  category: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type CategoryFilter = {
  category?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
};

export type CategoryConnectionEdges = {
  __typename?: 'CategoryConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Category>;
};

export type CategoryConnection = Connection & {
  __typename?: 'CategoryConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<CategoryConnectionEdges>>>;
};

export type LessonLines = {
  __typename?: 'LessonLines';
  moves?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LessonChallengeLines = {
  __typename?: 'LessonChallengeLines';
  moves?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Lesson = Node & Document & {
  __typename?: 'Lesson';
  lesson: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  description: Scalars['String']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  openingFen?: Maybe<Scalars['String']['output']>;
  openingLastMove?: Maybe<Scalars['String']['output']>;
  playingWhite?: Maybe<Scalars['Boolean']['output']>;
  lines?: Maybe<Array<Maybe<LessonLines>>>;
  challengeFen?: Maybe<Scalars['String']['output']>;
  challengeOpeningLastMove?: Maybe<Scalars['String']['output']>;
  challengeLines?: Maybe<Array<Maybe<LessonChallengeLines>>>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type LessonLinesFilter = {
  moves?: InputMaybe<StringFilter>;
  comments?: InputMaybe<StringFilter>;
};

export type LessonChallengeLinesFilter = {
  moves?: InputMaybe<StringFilter>;
  comments?: InputMaybe<StringFilter>;
};

export type LessonFilter = {
  lesson?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  introText?: InputMaybe<StringFilter>;
  openingFen?: InputMaybe<StringFilter>;
  openingLastMove?: InputMaybe<StringFilter>;
  playingWhite?: InputMaybe<BooleanFilter>;
  lines?: InputMaybe<LessonLinesFilter>;
  challengeFen?: InputMaybe<StringFilter>;
  challengeOpeningLastMove?: InputMaybe<StringFilter>;
  challengeLines?: InputMaybe<LessonChallengeLinesFilter>;
  body?: InputMaybe<RichTextFilter>;
};

export type LessonConnectionEdges = {
  __typename?: 'LessonConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Lesson>;
};

export type LessonConnection = Connection & {
  __typename?: 'LessonConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<LessonConnectionEdges>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPendingDocument: DocumentNode;
  updateDocument: DocumentNode;
  deleteDocument: DocumentNode;
  createDocument: DocumentNode;
  createFolder: DocumentNode;
  updatePost: Post;
  createPost: Post;
  updateAuthor: Author;
  createAuthor: Author;
  updateCategory: Category;
  createCategory: Category;
  updateLesson: Lesson;
  createLesson: Lesson;
};


export type MutationAddPendingDocumentArgs = {
  collection: Scalars['String']['input'];
  relativePath: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentUpdateMutation;
};


export type MutationDeleteDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentMutation;
};


export type MutationCreateFolderArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationUpdatePostArgs = {
  relativePath: Scalars['String']['input'];
  params: PostMutation;
};


export type MutationCreatePostArgs = {
  relativePath: Scalars['String']['input'];
  params: PostMutation;
};


export type MutationUpdateAuthorArgs = {
  relativePath: Scalars['String']['input'];
  params: AuthorMutation;
};


export type MutationCreateAuthorArgs = {
  relativePath: Scalars['String']['input'];
  params: AuthorMutation;
};


export type MutationUpdateCategoryArgs = {
  relativePath: Scalars['String']['input'];
  params: CategoryMutation;
};


export type MutationCreateCategoryArgs = {
  relativePath: Scalars['String']['input'];
  params: CategoryMutation;
};


export type MutationUpdateLessonArgs = {
  relativePath: Scalars['String']['input'];
  params: LessonMutation;
};


export type MutationCreateLessonArgs = {
  relativePath: Scalars['String']['input'];
  params: LessonMutation;
};

export type DocumentUpdateMutation = {
  post?: InputMaybe<PostMutation>;
  author?: InputMaybe<AuthorMutation>;
  category?: InputMaybe<CategoryMutation>;
  lesson?: InputMaybe<LessonMutation>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMutation = {
  post?: InputMaybe<PostMutation>;
  author?: InputMaybe<AuthorMutation>;
  category?: InputMaybe<CategoryMutation>;
  lesson?: InputMaybe<LessonMutation>;
};

export type PostOpeningVariationsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  moves?: InputMaybe<Scalars['String']['input']>;
  fen?: InputMaybe<Scalars['String']['input']>;
};

export type PostOpeningMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  moves?: InputMaybe<Scalars['String']['input']>;
  lessonSlug?: InputMaybe<Scalars['String']['input']>;
  ecoCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  side?: InputMaybe<Scalars['String']['input']>;
  skillLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyIdeas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variations?: InputMaybe<Array<InputMaybe<PostOpeningVariationsMutation>>>;
};

export type PostHeroBoardArrowsMutation = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
};

export type PostHeroBoardHighlightsMutation = {
  square?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};

export type PostHeroBoardMutation = {
  fen?: InputMaybe<Scalars['String']['input']>;
  playingWhite?: InputMaybe<Scalars['Boolean']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  arrows?: InputMaybe<Array<InputMaybe<PostHeroBoardArrowsMutation>>>;
  highlights?: InputMaybe<Array<InputMaybe<PostHeroBoardHighlightsMutation>>>;
};

export type PostMutation = {
  postId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  subtopic?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  isSubtopicPage?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  opening?: InputMaybe<PostOpeningMutation>;
  excerpt?: InputMaybe<Scalars['JSON']['input']>;
  heroBoard?: InputMaybe<PostHeroBoardMutation>;
  heroImg?: InputMaybe<Scalars['String']['input']>;
  cardImg?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  _body?: InputMaybe<Scalars['JSON']['input']>;
};

export type AuthorMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  xHandle?: InputMaybe<Scalars['String']['input']>;
  _body?: InputMaybe<Scalars['JSON']['input']>;
};

export type CategoryMutation = {
  category?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type LessonLinesMutation = {
  moves?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LessonChallengeLinesMutation = {
  moves?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LessonMutation = {
  lesson?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  openingFen?: InputMaybe<Scalars['String']['input']>;
  openingLastMove?: InputMaybe<Scalars['String']['input']>;
  playingWhite?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<Array<InputMaybe<LessonLinesMutation>>>;
  challengeFen?: InputMaybe<Scalars['String']['input']>;
  challengeOpeningLastMove?: InputMaybe<Scalars['String']['input']>;
  challengeLines?: InputMaybe<Array<InputMaybe<LessonChallengeLinesMutation>>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type PostPartsFragment = { __typename: 'Post', postId: string, title: string, subtitle?: string | null, slug?: string | null, subtopic?: string | null, template: string, isSubtopicPage?: boolean | null, locale?: string | null, excerpt?: any | null, heroImg?: string | null, cardImg?: string | null, date?: string | null, _body?: any | null, category?: { __typename: 'Category', category: string, slug: string, description: string, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, opening?: { __typename: 'PostOpening', name?: string | null, moves?: string | null, lessonSlug?: string | null, ecoCodes?: Array<string | null> | null, aliases?: Array<string | null> | null, side?: string | null, skillLevels?: Array<string | null> | null, character?: Array<string | null> | null, keyIdeas?: Array<string | null> | null, variations?: Array<{ __typename: 'PostOpeningVariations', name: string, moves?: string | null, fen?: string | null } | null> | null } | null, heroBoard?: { __typename: 'PostHeroBoard', fen: string, playingWhite?: boolean | null, caption?: string | null, arrows?: Array<{ __typename: 'PostHeroBoardArrows', from?: string | null, to?: string | null, color?: string | null, opacity?: number | null } | null> | null, highlights?: Array<{ __typename: 'PostHeroBoardHighlights', square?: string | null, color?: string | null, opacity?: number | null, style?: string | null } | null> | null } | null, author?: { __typename: 'Author', name: string, title?: string | null, xHandle?: string | null, _body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null };

export type AuthorPartsFragment = { __typename: 'Author', name: string, title?: string | null, xHandle?: string | null, _body?: any | null };

export type CategoryPartsFragment = { __typename: 'Category', category: string, slug: string, description: string };

export type LessonPartsFragment = { __typename: 'Lesson', lesson: string, slug: string, description: string, introText?: string | null, openingFen?: string | null, openingLastMove?: string | null, playingWhite?: boolean | null, challengeFen?: string | null, challengeOpeningLastMove?: string | null, body?: any | null, lines?: Array<{ __typename: 'LessonLines', moves?: string | null, comments?: Array<string | null> | null } | null> | null, challengeLines?: Array<{ __typename: 'LessonChallengeLines', moves?: string | null, comments?: Array<string | null> | null } | null> | null };

export type PostQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PostQuery = { __typename?: 'Query', post: { __typename: 'Post', id: string, postId: string, title: string, subtitle?: string | null, slug?: string | null, subtopic?: string | null, template: string, isSubtopicPage?: boolean | null, locale?: string | null, excerpt?: any | null, heroImg?: string | null, cardImg?: string | null, date?: string | null, _body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, category?: { __typename: 'Category', category: string, slug: string, description: string, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, opening?: { __typename: 'PostOpening', name?: string | null, moves?: string | null, lessonSlug?: string | null, ecoCodes?: Array<string | null> | null, aliases?: Array<string | null> | null, side?: string | null, skillLevels?: Array<string | null> | null, character?: Array<string | null> | null, keyIdeas?: Array<string | null> | null, variations?: Array<{ __typename: 'PostOpeningVariations', name: string, moves?: string | null, fen?: string | null } | null> | null } | null, heroBoard?: { __typename: 'PostHeroBoard', fen: string, playingWhite?: boolean | null, caption?: string | null, arrows?: Array<{ __typename: 'PostHeroBoardArrows', from?: string | null, to?: string | null, color?: string | null, opacity?: number | null } | null> | null, highlights?: Array<{ __typename: 'PostHeroBoardHighlights', square?: string | null, color?: string | null, opacity?: number | null, style?: string | null } | null> | null } | null, author?: { __typename: 'Author', name: string, title?: string | null, xHandle?: string | null, _body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } };

export type PostConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostFilter>;
}>;


export type PostConnectionQuery = { __typename?: 'Query', postConnection: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PostConnectionEdges', cursor: string, node?: { __typename: 'Post', id: string, postId: string, title: string, subtitle?: string | null, slug?: string | null, subtopic?: string | null, template: string, isSubtopicPage?: boolean | null, locale?: string | null, excerpt?: any | null, heroImg?: string | null, cardImg?: string | null, date?: string | null, _body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, category?: { __typename: 'Category', category: string, slug: string, description: string, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, opening?: { __typename: 'PostOpening', name?: string | null, moves?: string | null, lessonSlug?: string | null, ecoCodes?: Array<string | null> | null, aliases?: Array<string | null> | null, side?: string | null, skillLevels?: Array<string | null> | null, character?: Array<string | null> | null, keyIdeas?: Array<string | null> | null, variations?: Array<{ __typename: 'PostOpeningVariations', name: string, moves?: string | null, fen?: string | null } | null> | null } | null, heroBoard?: { __typename: 'PostHeroBoard', fen: string, playingWhite?: boolean | null, caption?: string | null, arrows?: Array<{ __typename: 'PostHeroBoardArrows', from?: string | null, to?: string | null, color?: string | null, opacity?: number | null } | null> | null, highlights?: Array<{ __typename: 'PostHeroBoardHighlights', square?: string | null, color?: string | null, opacity?: number | null, style?: string | null } | null> | null } | null, author?: { __typename: 'Author', name: string, title?: string | null, xHandle?: string | null, _body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null } | null> | null } };

export type AuthorQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AuthorQuery = { __typename?: 'Query', author: { __typename: 'Author', id: string, name: string, title?: string | null, xHandle?: string | null, _body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type AuthorConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuthorFilter>;
}>;


export type AuthorConnectionQuery = { __typename?: 'Query', authorConnection: { __typename?: 'AuthorConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'AuthorConnectionEdges', cursor: string, node?: { __typename: 'Author', id: string, name: string, title?: string | null, xHandle?: string | null, _body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type CategoryQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', category: { __typename: 'Category', id: string, category: string, slug: string, description: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type CategoryConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CategoryFilter>;
}>;


export type CategoryConnectionQuery = { __typename?: 'Query', categoryConnection: { __typename?: 'CategoryConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'CategoryConnectionEdges', cursor: string, node?: { __typename: 'Category', id: string, category: string, slug: string, description: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type LessonQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type LessonQuery = { __typename?: 'Query', lesson: { __typename: 'Lesson', id: string, lesson: string, slug: string, description: string, introText?: string | null, openingFen?: string | null, openingLastMove?: string | null, playingWhite?: boolean | null, challengeFen?: string | null, challengeOpeningLastMove?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, lines?: Array<{ __typename: 'LessonLines', moves?: string | null, comments?: Array<string | null> | null } | null> | null, challengeLines?: Array<{ __typename: 'LessonChallengeLines', moves?: string | null, comments?: Array<string | null> | null } | null> | null } };

export type LessonConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LessonFilter>;
}>;


export type LessonConnectionQuery = { __typename?: 'Query', lessonConnection: { __typename?: 'LessonConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'LessonConnectionEdges', cursor: string, node?: { __typename: 'Lesson', id: string, lesson: string, slug: string, description: string, introText?: string | null, openingFen?: string | null, openingLastMove?: string | null, playingWhite?: boolean | null, challengeFen?: string | null, challengeOpeningLastMove?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, hasReferences?: boolean | null, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, lines?: Array<{ __typename: 'LessonLines', moves?: string | null, comments?: Array<string | null> | null } | null> | null, challengeLines?: Array<{ __typename: 'LessonChallengeLines', moves?: string | null, comments?: Array<string | null> | null } | null> | null } | null } | null> | null } };

export const PostPartsFragmentDoc = gql`
    fragment PostParts on Post {
  __typename
  postId
  title
  subtitle
  slug
  category {
    ... on Category {
      __typename
      category
      slug
      description
    }
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  subtopic
  template
  isSubtopicPage
  locale
  opening {
    __typename
    name
    moves
    lessonSlug
    ecoCodes
    aliases
    side
    skillLevels
    character
    keyIdeas
    variations {
      __typename
      name
      moves
      fen
    }
  }
  excerpt
  heroBoard {
    __typename
    fen
    playingWhite
    caption
    arrows {
      __typename
      from
      to
      color
      opacity
    }
    highlights {
      __typename
      square
      color
      opacity
      style
    }
  }
  heroImg
  cardImg
  author {
    ... on Author {
      __typename
      name
      title
      xHandle
      _body
    }
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  date
  _body
}
    `;
export const AuthorPartsFragmentDoc = gql`
    fragment AuthorParts on Author {
  __typename
  name
  title
  xHandle
  _body
}
    `;
export const CategoryPartsFragmentDoc = gql`
    fragment CategoryParts on Category {
  __typename
  category
  slug
  description
}
    `;
export const LessonPartsFragmentDoc = gql`
    fragment LessonParts on Lesson {
  __typename
  lesson
  slug
  description
  introText
  openingFen
  openingLastMove
  playingWhite
  lines {
    __typename
    moves
    comments
  }
  challengeFen
  challengeOpeningLastMove
  challengeLines {
    __typename
    moves
    comments
  }
  body
}
    `;
export const PostDocument = gql`
    query post($relativePath: String!) {
  post(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PostParts
  }
}
    ${PostPartsFragmentDoc}`;
export const PostConnectionDocument = gql`
    query postConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PostFilter) {
  postConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PostParts
      }
    }
  }
}
    ${PostPartsFragmentDoc}`;
export const AuthorDocument = gql`
    query author($relativePath: String!) {
  author(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...AuthorParts
  }
}
    ${AuthorPartsFragmentDoc}`;
export const AuthorConnectionDocument = gql`
    query authorConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: AuthorFilter) {
  authorConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...AuthorParts
      }
    }
  }
}
    ${AuthorPartsFragmentDoc}`;
export const CategoryDocument = gql`
    query category($relativePath: String!) {
  category(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CategoryParts
  }
}
    ${CategoryPartsFragmentDoc}`;
export const CategoryConnectionDocument = gql`
    query categoryConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CategoryFilter) {
  categoryConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CategoryParts
      }
    }
  }
}
    ${CategoryPartsFragmentDoc}`;
export const LessonDocument = gql`
    query lesson($relativePath: String!) {
  lesson(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...LessonParts
  }
}
    ${LessonPartsFragmentDoc}`;
export const LessonConnectionDocument = gql`
    query lessonConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: LessonFilter) {
  lessonConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...LessonParts
      }
    }
  }
}
    ${LessonPartsFragmentDoc}`;
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
  export function getSdk<C>(requester: Requester<C>) {
    return {
      post(variables: PostQueryVariables, options?: C): Promise<{data: PostQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostQueryVariables, query: string}> {
        return requester<{data: PostQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostQueryVariables, query: string}, PostQueryVariables>(PostDocument, variables, options);
      },
    postConnection(variables?: PostConnectionQueryVariables, options?: C): Promise<{data: PostConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostConnectionQueryVariables, query: string}> {
        return requester<{data: PostConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostConnectionQueryVariables, query: string}, PostConnectionQueryVariables>(PostConnectionDocument, variables, options);
      },
    author(variables: AuthorQueryVariables, options?: C): Promise<{data: AuthorQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorQueryVariables, query: string}> {
        return requester<{data: AuthorQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorQueryVariables, query: string}, AuthorQueryVariables>(AuthorDocument, variables, options);
      },
    authorConnection(variables?: AuthorConnectionQueryVariables, options?: C): Promise<{data: AuthorConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorConnectionQueryVariables, query: string}> {
        return requester<{data: AuthorConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AuthorConnectionQueryVariables, query: string}, AuthorConnectionQueryVariables>(AuthorConnectionDocument, variables, options);
      },
    category(variables: CategoryQueryVariables, options?: C): Promise<{data: CategoryQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryQueryVariables, query: string}> {
        return requester<{data: CategoryQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryQueryVariables, query: string}, CategoryQueryVariables>(CategoryDocument, variables, options);
      },
    categoryConnection(variables?: CategoryConnectionQueryVariables, options?: C): Promise<{data: CategoryConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryConnectionQueryVariables, query: string}> {
        return requester<{data: CategoryConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CategoryConnectionQueryVariables, query: string}, CategoryConnectionQueryVariables>(CategoryConnectionDocument, variables, options);
      },
    lesson(variables: LessonQueryVariables, options?: C): Promise<{data: LessonQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: LessonQueryVariables, query: string}> {
        return requester<{data: LessonQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: LessonQueryVariables, query: string}, LessonQueryVariables>(LessonDocument, variables, options);
      },
    lessonConnection(variables?: LessonConnectionQueryVariables, options?: C): Promise<{data: LessonConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: LessonConnectionQueryVariables, query: string}> {
        return requester<{data: LessonConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: LessonConnectionQueryVariables, query: string}, LessonConnectionQueryVariables>(LessonConnectionDocument, variables, options);
      }
    };
  }
  export type Sdk = ReturnType<typeof getSdk>;

// TinaSDK generated code
import { createClient, TinaClient } from "tinacms/dist/client";

const generateRequester = (
  client: TinaClient,
) => {
  const requester: (
    doc: any,
    vars?: any,
    options?: {
      branch?: string,
      /**
       * Aside from `method` and `body`, all fetch options are passed
       * through to underlying fetch request
       */
      fetchOptions?: Omit<Parameters<typeof fetch>[1], 'body' | 'method'>,
    },
    client
  ) => Promise<any> = async (doc, vars, options) => {
    let url = client.apiUrl
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf('/')
      url = client.apiUrl.substring(0, index + 1) + options.branch
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url,
    }, options)

    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} }
  }

  return requester
}

/**
 * @experimental this class can be used but may change in the future
 **/
export const ExperimentalGetTinaClient = () =>
  getSdk(
    generateRequester(
      createClient({
        url: "http://localhost:4407/graphql",
        queries,
      })
    )
  )

export const queries = (
  client: TinaClient,
) => {
  const requester = generateRequester(client)
  return getSdk(requester)
}

  